import { useContext } from 'react';
import { FormContext, IFormContext } from 'context';

const useFormData = (): IFormContext => useContext(FormContext);

export default useFormData;
